import type { AxiosInstance } from "axios";
import type { EventIdPublic } from "@shared/schemas/branded-id.schemas";
import { participantRosterUrl } from "../participant-roster/participant-roster.api";

export function createEventParticipantsAdminApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getEventParticipants(
    eventIdPublic: EventIdPublic,
  ): Promise<unknown> {
    const response = await apiClient.get(participantRosterUrl(eventIdPublic));
    return response.data;
  }

  return { getEventParticipants };
}
